// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"7aca9356","453":"edd4a359","465":"0789d2a1","832":"ee38b0e2","957":"0be28825"}[chunkId] + ".chunk.js";
};